var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 37,
    viewBox: "0 0 61 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.5H60.6857V9.5H54.6171L57.6514 36.5H50.0657L48.3665 21.5H12.3192L10.62 36.5H3.03429L6.06857 9.5H0V0.5ZM47.0314 9.5H13.6543L13.0171 15.5H47.6686L47.0314 9.5Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTable);
export default __webpack_public_path__ + "static/media/small_table.a2b634020aa61205eda744c1bc5fce86.svg";
export { ForwardRef as ReactComponent };